// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"27944983","82":"e32b915d","127":"f875f74f","453":"d5b9e7ff","455":"6d5d5d02","462":"6cac92fd","644":"cea5e6cb","869":"e260b351"}[chunkId] + ".chunk.js";
};